<template>
    <div class="col-xs-3">
        <h2 class="subtitle">Filter</h2>
        <ul class="filtering">
            <li class="filtering-section"
                :class="[isBrandsOpen ? openClass : '']">
                <strong :data-active-filters-count="brandOptionsCount"
                        v-on:click="isBrandsOpen = !isBrandsOpen">
                    Mærker
                </strong>
                <div class="filtering-accordion-wrapper">
                    <div class="filtering-accordion-inner">
                        <div class="filtering-accordion-content">

                            <article class="filtering-checklist">
                                <ul class="filtering-checklist-items">
                                    <li class="filtering-checklist-item"
                                        v-for="(brand, index) in brandOptions"
                                        :key="index">
                                        <label>
                                            <input type="checkbox"
                                                   :id="brand.value"
                                                   name="brand.text"
                                                   :value="brand.value"
                                                   v-model="selectedBrands" />
                                            <span class="filtering-checklist-item-marker">
                                                <svg class="icon"
                                                     width="24"
                                                     height="24">
                                                    <use href="/ui/icons/custom-sprite.svg#feather-check" />
                                                </svg>
                                            </span>
                                            <span class="filtering-checklist-item-text">{{ brand.text }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </article>

                        </div>
                    </div>
                </div>
            </li>
            <li class="filtering-section"
                :class="[isModelsOpen ? openClass : '']">
                <strong :data-active-filters-count="modelOptionsCount"
                        v-on:click="isModelsOpen = !isModelsOpen">
                    Modeller
                </strong>
                <div class="filtering-accordion-wrapper">
                    <div class="filtering-accordion-inner">
                        <div class="filtering-accordion-content">
                            <article class="filtering-checklist"
                                     v-for="modelGroup in modelGroups"
                                     :key="modelGroup.brand">
                                <h4 class="filtering-checklist-category-title">{{ formatBrand(modelGroup.brand) }}</h4>
                                <ul class="filtering-checklist-items">
                                    <li class="filtering-checklist-item"
                                        v-for="modelOption in modelGroup.modelOptions"
                                        :key="modelOption.value">
                                        <label>
                                            <input type="checkbox"
                                                   :id="modelOption.value"
                                                   name="modelOption.text"
                                                   :value="modelOption.value"
                                                   v-model="selectedModels" />
                                            <span class="filtering-checklist-item-marker">
                                                <svg class="icon"
                                                     width="24"
                                                     height="24">
                                                    <use href="/ui/icons/custom-sprite.svg#feather-check" />
                                                </svg>
                                            </span>
                                            <span class="filtering-checklist-item-text">{{ modelOption.text }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </article>
                        </div>
                    </div>
                </div>
            </li>
            <li class="filtering-section"
                :class="[isPropellantOpen ? openClass : '']">
                <strong :data-active-filters-count="propellantOptionsCount"
                        v-on:click="isPropellantOpen = !isPropellantOpen">
                    Drivmiddel
                </strong>
                <div class="filtering-accordion-wrapper">
                    <div class="filtering-accordion-inner">
                        <div class="filtering-accordion-content">
                            <article class="filtering-checklist">
                                <ul class="filtering-checklist-items">
                                    <li class="filtering-checklist-item"
                                        v-for="propellantOption in propellantOptions"
                                        :key="propellantOption.value">
                                        <label>
                                            <input type="checkbox"
                                                   :id="propellantOption.value"
                                                   name="propellantOption.text"
                                                   :value="propellantOption.value"
                                                   v-model="selectedPropellantOptions" />
                                            <span class="filtering-checklist-item-marker">
                                                <svg class="icon"
                                                     width="24"
                                                     height="24">
                                                    <use href="/ui/icons/custom-sprite.svg#feather-check" />
                                                </svg>
                                            </span>
                                            <span class="filtering-checklist-item-text">{{ propellantOption.text
                                                }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </article>
                        </div>
                    </div>
                </div>
            </li>
            <li class="filtering-section"
                :class="[isTaxBaseOpen ? openClass : '']">
                <strong :data-active-filters-count="taxBaseOptionsCount"
                        v-on:click="isTaxBaseOpen = !isTaxBaseOpen">
                    Beskatningsgrundlag
                </strong>
                <div class="filtering-accordion-wrapper">
                    <div class="filtering-accordion-inner">
                        <div class="filtering-accordion-content">

                            <article class="filtering-slider">
                                <ui-slider v-if="taxBaseRange"
                                           id="tax-base-slider"
                                           :single-slider="false"
                                           :enable-thousand-seperator="true"
                                           format-prefix=""
                                           format-suffix=" kr."
                                           :min-value="taxBaseRange.min"
                                           :max-value="taxBaseRange.max"
                                           :step="10000"
                                           :margin="100000"
                                           :init-value="initTaxBase"
                                           v-on:tax-base-slider="sendSelectedTaxBase"
                                           :key="resetKey" />
                            </article>

                        </div>
                    </div>
                </div>
            </li>
            <li class="filtering-section"
                :class="[isCo2Open ? openClass : '']">
                <strong :data-active-filters-count="co2OptionsCount"
                        v-on:click="isCo2Open = !isCo2Open">
                    CO2
                </strong>
                <div class="filtering-accordion-wrapper">
                    <div class="filtering-accordion-inner">
                        <div class="filtering-accordion-content">

                            <article class="filtering-slider">
                                <ui-slider v-if="co2Range"
                                           id="co2-slider"
                                           :single-slider="true"
                                           format-prefix="Op til "
                                           format-suffix=" CO2/km"
                                           :min-value="co2Range.min"
                                           :max-value="co2Range.max"
                                           :init-value="initCo2"
                                           v-on:co2-slider="sendSelectedCo2"
                                           :key="resetKey" />
                            </article>

                        </div>
                    </div>
                </div>
            </li>
            <li class="filtering-section"
                :class="[isTowingOpen ? openClass : '']">
                <strong :data-active-filters-count="towingOptionsCount"
                        v-on:click="isTowingOpen = !isTowingOpen">
                    Anhængervægt
                </strong>
                <div class="filtering-accordion-wrapper">
                    <div class="filtering-accordion-inner">
                        <div class="filtering-accordion-content">
                            <article class="filtering-slider">
                                <ui-slider v-if="towingRange"
                                           id="towing-slider"
                                           :single-slider="true"
                                           format-prefix="Mindst tilladt anhængervægt "
                                           format-suffix=" kg"
                                           :min-value="towingRange.min"
                                           :max-value="towingRange.max"
                                           :init-value="initTowing"
                                           v-on:towing-slider="sendSelectedTowing"
                                           :key="resetKey" />
                            </article>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <!-- 
            @peter, du bestemmer selv om reset-knappen skal være en <button> eller et <a href=""> 
            Bare class og svg er der, så er stylingen den samme.
        -->
        <button class="button filtering-reset-button has-icon"
                v-on:click.prevent="resetFilter">
            Nulstil filter
            <svg width="18"
                 height="18"
                 class="icon icon-md">
                <use href="/ui/icons/custom-sprite.svg#feather-refresh"></use>
            </svg>
        </button>
    </div>
</template>
<script>
import _ from 'qs';
import UiSlider from './UiSlider.vue';
import formatMixin from '../mixins/formatter.js'

export default {
    name: 'model-overview-filter-panel',
    mixins: [formatMixin],
    props: {
        brands: {
            type: Array,
            default: undefined
        },
        models: {
            type: Array,
            default: undefined
        },
        propellant: {
            type: Array,
            default: undefined
        },
        taxBase: {
            type: Object,
            default: function () { //factory method
                return { min: 10000, max: 20000 };
            }
        },
        co2: {
            type: Object,
            default: function () { //factory method
                return { min: 0, max: 200 };
            }
        },
        towing: {
            type: Object,
            default: () => ({ min: 0, max: 4000 })
        }
    },
    data() {
        return {
            isBrandsOpen: false,
            selectedBrands: [],

            isModelsOpen: false,
            selectedModels: [],

            isPropellantOpen: false,
            selectedPropellantOptions: [],

            isTaxBaseOpen: false,
            initTaxBase: undefined,

            isCo2Open: false,
            initCo2: undefined,

            isTowingOpen: false,
            initTowing: [0],

            openClass: 'is-open',
            skipReset: false,
            resetKey: 0
        }
    },
    mounted() {
        this.skipReset = true;
        this.loadPageState();

        // Force sliders to re-render with loaded values
        this.$nextTick(() => {
            this.resetKey += 1;
        });
    },
    computed: {
        brandOptions: function () {
            if (this.$props.brands) {
                return this.$props.brands;
            }

            return undefined;
        },
        brandOptionsCount: function () {
            if (this.$data.selectedBrands) {
                return this.$data.selectedBrands.length;
            }

            return undefined;
        },
        modelGroups: function () {
            if (this.$props.models) {
                return this.$props.models;
            }

            return undefined;
        },
        modelOptionsCount: function () {
            if (this.$data.selectedModels) {
                return this.$data.selectedModels.length;
            }

            return undefined;
        },
        propellantOptions: function () {
            if (this.$props.propellant) {
                return this.$props.propellant;
            }

            return undefined;
        },
        propellantOptionsCount: function () {
            if (this.$data.selectedPropellantOptions) {
                return this.$data.selectedPropellantOptions.length;
            }

            return undefined;
        },
        taxBaseRange: function () {
            if (this.$props.taxBase && !isNaN(this.$props.taxBase.min) && !isNaN(this.$props.taxBase.max)) {
                return this.$props.taxBase;
            }

            return undefined;
        },
        taxBaseOptionsCount: function () {
            if (this.initTaxBase && this.initTaxBase.length === 2 && this.taxBaseRange) {
                const isModified = this.initTaxBase[0] !== this.taxBaseRange.min || this.initTaxBase[1] !== this.taxBaseRange.max;
                return isModified ? 1 : 0;
            }
            return 0;
        },
        co2Range: function () {
            if (this.$props.co2 && !isNaN(this.$props.co2.min) && !isNaN(this.$props.co2.max)) {
                return this.$props.co2;
            }

            return undefined;
        },
        co2OptionsCount: function () {
            if (this.initCo2 && this.initCo2.length > 0 && this.co2Range) {
                const isModified = this.initCo2[0] < this.co2Range.max;
                return isModified ? 1 : 0;
            }
            return 0;
        },
        towingRange: function () {
            if (this.$props.towing && !isNaN(this.$props.towing.min) && !isNaN(this.$props.towing.max)) {
                return this.$props.towing;
            }
            return undefined;
        },
        towingOptionsCount: function () {
            if (this.initTowing && this.initTowing.length > 0) {
                const isModified = this.initTowing[0] > 0;
                return isModified ? 1 : 0;
            }
            return 0;
        }
    },
    methods: {
        sendSelectedBrands: function () {
            this.$emit("brands", this.$data.selectedBrands);
        },
        sendSelectedModels: function () {
            this.$emit("models", this.$data.selectedModels);
        },
        sendSelectedPropellants: function () {
            this.$emit("propellants", this.$data.selectedPropellantOptions);
        },
        sendSelectedTaxBase: function (value) {
            this.initTaxBase = value;
            this.$emit("taxbase", value);
        },
        sendSelectedCo2: function (value) {
            this.initCo2 = value;
            this.$emit("co2", value);
        },
        sendSelectedTowing: function (value) {
            this.initTowing = value;
            this.$emit("towing", value);
        },
        loadPageState: function () {
            console.log('[CHILD] Loading state from localStorage:', {
                brands: localStorage.selectedBrands,
                models: localStorage.selectedModels,
                propellants: localStorage.selectedPropellants
            });

            if (this.isValidState(localStorage.selectedBrands)) {
                this.selectedBrands = localStorage.selectedBrands.split(',').filter(x => x !== '');
            }

            if (this.isValidState(localStorage.selectedModels)) {
                this.selectedModels = localStorage.selectedModels.split(',').filter(x => x !== '');
            }

            if (this.isValidState(localStorage.selectedPropellants)) {
                this.selectedPropellantOptions = localStorage.selectedPropellants.split(',').filter(x => x !== '');
            }

            if (this.isValidState(localStorage.selectedCO2)) {
                this.initCo2 = localStorage.selectedCO2.split(',').filter(x => x !== '').map(Number);
                this.sendSelectedCo2(this.initCo2);
            }

            if (this.isValidState(localStorage.selectedTaxBase)) {
                this.initTaxBase = localStorage.selectedTaxBase.split(',').filter(x => x !== '').map(Number);
                this.sendSelectedTaxBase(this.initTaxBase);
            }

            if (this.isValidState(localStorage.selectedTowing)) {
                this.initTowing = localStorage.selectedTowing.split(',').filter(x => x !== '').map(Number);
                this.sendSelectedTowing(this.initTowing);
            }
        },
        isValidState: function (value) {
            if (value !== undefined && value !== '' && value !== 'undefined') {
                return true;
            }

            return false;
        },
        resetFilter: function () {
            this.selectedBrands = [];
            this.selectedModels = [];
            this.selectedPropellantOptions = [];
            this.initTaxBase = [this.$props.taxBase.min, this.$props.taxBase.max];
            this.initCo2 = [this.$props.co2.max];
            this.initTowing = [0];

            this.isBrandsOpen = false;
            this.isModelsOpen = false;
            this.isPropellantOpen = false;
            this.isTaxBaseOpen = false;
            this.isCo2Open = false;
            this.isTowingOpen = false;

            this.resetKey += 1;

            // Clear localStorage
            localStorage.removeItem('selectedBrands');
            localStorage.removeItem('selectedModels');
            localStorage.removeItem('selectedPropellants');
            localStorage.removeItem('selectedCO2');
            localStorage.removeItem('selectedTaxBase');
            localStorage.removeItem('selectedTowing');
        }
    },
    watch: {
        selectedBrands: function () {
            console.log('[CHILD WATCH] selectedBrands changed:', this.selectedBrands, 'skipReset:', this.skipReset);
            this.sendSelectedBrands();

            //reset selected models
            if (this.skipReset) {
                this.skipReset = false;
            } else {
                console.log('[CHILD WATCH] Resetting selectedModels to empty');
                this.$data.selectedModels = [];
            }
        },
        selectedModels: function () {
            this.sendSelectedModels();
        },
        selectedPropellantOptions: function () {
            this.sendSelectedPropellants();
        }
    },
    components: {
        UiSlider
    }
}
</script>